import React from 'react'
import PropTypes from 'prop-types'
import { navigate, graphql } from 'gatsby'
import { withTranslation, Trans } from 'gatsby-plugin-react-i18next'
import YotpoStars from 'src/components/YotpoStars'
import theme from 'src/utils/styles/theme'
import { GatsbyImage } from 'gatsby-plugin-image'
import Analytics from 'src/utils/Analytics'
import SEO from 'src/components/seo'
import StoreContext from 'src/context/StoreContext'
import { DefaultCalendarSelection, GetCtaDetails } from 'src/utils/FrameProductPage'
import { FormattedCurrency } from 'src/utils/FormattedCurrency'
import {
  Header,
  Subheader,
  Centered,
  CustomizationOption,
  FrameProductOptions,
} from 'src/components/FrameProductForm/styles'
// import DiscountBanner from '../../components/DiscountBanner'
import BetterHelpBanner from '../../components/temp/BetterHelpBanner'

import { Anchor } from '../../components/ReviewsSection/styles'

import {
  ShopifyDescription,
  Thumbnail,
  ThumbnailRow,
  ThumbnailButton,
  Section,
  Container,
  ProductGridLeft,
  ProductGridRight,
  Grid,
  ProductImage,
  ArrowContainer,
  LeftArrow,
  RightArrow,
} from '../FrameProductPage/styles'

import {
  StyleText,
  SubLabel,
  CalMaxIcon,
  StyleOptionsContainer,
  SelectionOption,
  StyleDescription,
  LimitedAvailable,
  Badge,
  HeaderContainer,
  PickPriceContainer,
  GiftModeImage,
  CalFeatureRow,
  CalFeature,
  CalFeatureHeading,
  CalFeatureText,
  IconContainer,
  PlusPlanIncludes,
  ProductSelectionBoxWrapper,
  ProductSelectionBox,
  ProductSelectionPricePoint,
  ClickableProductSelectionPricePoint,
  ClickableProductSelectionBox,
  ProductSelectionHeaderRow,
  ProductSelectionHeader,
  RadioIconContainer,
  MostPopular,
  PriceAndExplainerContainer,
  OneTimePurchase,
  SaveInfo,
  PlanHeading,
  DropDownContainer,
  DropDownContainerOptions,
  DropDownLabel,
  DropDownLabelOption,
  DropDownImageContainer,
  DropDownIconContainer,
  ThumbnailVideo,
  CalendarVideoThumbnail,
  VideoContainer,
  // VideoTouchOverlay,
  Bubble,
  ComingSoon,
  Strikethough,
  Price,
  // Card,
  // Checkbox,
  // Content,
  // Title,
  // Description,
  // PriceRow,
  // WasPrice,
  // NowPrice,
  // SaleBadge,
} from './styles'
import ColorSelectionItem from '../../components/ColorSelectionItem'
import ReviewsSection from '../../components/ReviewsSection'
import {
  IS_FOREIGN_COUNTRY,
  IN_UK,
  currencyCode,
  LOCALIZATION,
  CAL_BUY_LINK,
  DOMESTIC_CAL_BUY_LINK,
  INTL_CAL_BUY_LINK,
  SHOW_BETTER_HELP_DESIGN,
} from '../../utils/constants'
import CalendarSyncs from '../../components/CalendarSyncs'
import {
  CAL_PLUS_FEATURES,
  PRODUCT_DROPDOWN_LABELS,
  CAL_SIZE_PRICING,
  CA_CALENDAR_FIFTEEN,
} from './constants'
import ShopPay from '../../components/temp/ShopPay'
import FAQs from '../../components/FAQs'
import ShippingDetails from '../../components/ShippingDetails'
import AddToCartButton from '../../components/AddToCartButton'

import calProductVideo from '../../images/cal-pdp-video-thumbnail.webp'
import { addReturnGuarantee } from '../../utils/addReturnGuarantee'

import Backorder from '../../components/Backorder'
import ToolTip from '../../components/temp/ToolTip'

const HREF_LANG_PATH_OVERRIDES = {
  'en-au': INTL_CAL_BUY_LINK,
  'en-ca': INTL_CAL_BUY_LINK,
  'en-gb': INTL_CAL_BUY_LINK,
  'en-us': DOMESTIC_CAL_BUY_LINK,
  'x-default': DOMESTIC_CAL_BUY_LINK,
}

const defaultLanguage = process.env.GATSBY_I18N_DEFAULT_LANGUAGE

class CalendarProductPage extends React.Component {
  constructor(props) {
    const defaultSize = 15
    super(props)
    this.state = {
      shownImageIndex: 0,
      size: defaultSize,
      color: IS_FOREIGN_COUNTRY || defaultSize === 15 ? 'White' : 'Natural Aluminum',
      style: IS_FOREIGN_COUNTRY || defaultSize === 15 ? 'Classic' : 'Shadow Box',
      isPlusProduct: true,
      submitting: false,
      showDropdown: false,
      showVideo: false,
      isScrollable: false,
      Cal10Offer: false,
      Cal15Offer: false,
      checked: false,
      displayToolTip: false,
      isMobile: false,
      // selected: false,
    }
    this.handleSizeSelection = this.handleSizeSelection.bind(this)
    this.handleStyleSelection = this.handleStyleSelection.bind(this)
    this.handleColorSelection = this.handleColorSelection.bind(this)
    this.setShownImageIndex = this.setShownImageIndex.bind(this)
    this.handleAddToCart = this.handleAddToCart.bind(this)
    this.setShowDropdown = this.setShowDropdown.bind(this)
    this.handlePlusProduct = this.handlePlusProduct.bind(this)
    this.noplusSelectionRef = React.createRef()
    this.scrollableThumbnailContainerRef = React.createRef()
    this.handleOfferSelection = this.handleOfferSelection.bind(this)
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
    this.setDisplayToolTip = this.setDisplayToolTip.bind(this)
    this.updateMedia = this.updateMedia.bind(this)
    this.hasFiredKey = null
    this.trackProductView = this.trackProductView.bind(this)
    this.handleTouchStart = this.handleTouchStart.bind(this)
    this.handleTouchMove = this.handleTouchMove.bind(this)
    this.handleTouchEnd = this.handleTouchEnd.bind(this)
    this.touchStartX = React.createRef()
    this.touchLastX = React.createRef()
    this.touchLastTime = React.createRef()
    // this.toggleSelected = this.toggleSelected.bind(this)
  }

  componentDidMount() {
    this.checkIfScrollable()
    this.updateMedia()

    const {
      data: { product },
      pageContext: { calMaxShadowBoxNaturalAluminum, calMaxClassicWhite },
    } = this.props

    const { size, color, style } = this.state
    let sku
    let handle
    const isExactMatch = window.location.href
      .split('/')
      .some((segment) => segment === 'skylight-calendar-max')
    let url = window.location.href
    if (url.endsWith('/')) {
      url = url.slice(0, -1)
    }
    const urlParams = new URLSearchParams(new URL(url).search)
    // const utmCampaign = urlParams.get('utm_campaign')
    const utmCampaignAll = urlParams.getAll('utm_campaign')
    const utmCampaign = utmCampaignAll.length > 0 ? utmCampaignAll[0] : null
    const utmDeal = urlParams.get('utm_deal')
    const utmTermAll = urlParams.getAll('utm_term')
    const utmTerm = utmTermAll.length > 0 ? utmTermAll[0] : null
    if (utmCampaign === 'gma' || utmTerm === 'gma') {
      const { updateBanner } = this.context
      const channel = 'GMA'
      const amount = '50'
      updateBanner('GMA', channel, amount)
    } else if (utmCampaign === 'today' || utmTerm === 'today') {
      const { updateBanner } = this.context
      const channel = 'TODAY'
      const amount = '20%'
      updateBanner('TODAY', channel, amount)
    } else {
      const { checkUtmParamsForPromo } = this.context
      checkUtmParamsForPromo(window.location.search)
    }
    if (isExactMatch) {
      if (IS_FOREIGN_COUNTRY) {
        sku = calMaxClassicWhite.data.shopifyProduct.variants[0].sku
        handle = calMaxClassicWhite.data.shopifyProduct.handle
      } else {
        sku = calMaxShadowBoxNaturalAluminum.data.shopifyProduct.variants[0].sku
        handle = calMaxShadowBoxNaturalAluminum.data.shopifyProduct.handle
      }
      if (utmDeal) {
        const { updateBanner } = this.context
        updateBanner(utmTerm, 'InfluencerMax', utmDeal)
      }
    } else {
      sku = product.variants[0].sku
      handle = product.handle
    }
    if (handle === 'the-skylight-calendar-pro-149') {
      this.setState({ size: 10, isPlusProduct: handle === 'the-skylight-calendar-pro-149' })
    }
    setTimeout(() => {
      Analytics.track(`Viewed Calendar Product Page`, { sku })
    }, 3000)
    if (handle.includes('max') || handle.includes('charcoal')) {
      const designDefault = DefaultCalendarSelection(handle, { size, color, style })
      this.setState(designDefault)
    }
    this.trackProductView()
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPlusProduct, size, style, color } = this.state

    if (prevState.isPlusProduct !== isPlusProduct && !isPlusProduct) {
      if (this.noplusSelectionRef.current) {
        const elementPosition =
          this.noplusSelectionRef.current.getBoundingClientRect().top + window.scrollY
        const bannerElement = document.querySelector('.banner')
        const scrollOffset = bannerElement ? bannerElement.offsetHeight + 80 : 80
        window.scrollTo({
          top: elementPosition - scrollOffset,
          behavior: 'smooth',
        })
      }
    }

    const currentKey = `${size}-${style}-${color}`
    if (this.hasFiredKey === currentKey) return

    const productInfo = this.getProductInfo()
    const selectedProduct = isPlusProduct ? productInfo.withPlus : productInfo.calendar
    const productDetails = {
      id: selectedProduct?.shopifyId,
      name: selectedProduct?.name,
      category: 'Calendar',
      price: selectedProduct?.price,
      quantity: 1,
    }

    if (!productDetails.id || !productDetails.name || productDetails.price == null) return

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'view_item',
      ecommerce: {
        currencyCode,
        add: {
          products: [productDetails],
        },
      },
    })

    this.hasFiredKey = currentKey
  }

  handleSizeSelection(size) {
    this.setState({ size }, () => {
      this.trackProductView()
    })
    if (size === 15 && !IS_FOREIGN_COUNTRY) {
      this.setState({ color: 'White', style: 'Classic' })
    }
    if (size === 27 && !IS_FOREIGN_COUNTRY) {
      this.setState({ color: 'Natural Aluminum', style: 'Shadow Box' })
    }
  }

  handleStyleSelection(style) {
    const { size } = this.state
    const color =
      style === 'Classic'
        ? 'White'
        : IS_FOREIGN_COUNTRY || size === 27
        ? 'Natural Aluminum'
        : 'Charcoal'
    this.setState({ style, color }, () => {
      this.trackProductView()
    })
    Analytics.track(`Viewed ${size}in Cal ${style} ${color} Toggle Product Page`)
  }

  handleColorSelection(color) {
    const { size, style } = this.state
    this.setState({ color }, () => {
      this.trackProductView()
    })
    Analytics.track(`Viewed ${size}in Cal ${style} ${color} Toggle Product Page`)
  }

  handlePlusProduct(bool) {
    this.setState({ isPlusProduct: bool }, () => {
      this.trackProductView()
    })
  }

  handleOfferSelection(size, bool) {
    const key = `${size}Offer`
    this.setState({ [key]: bool })
  }

  handleCheckboxChange(bool) {
    this.setState({ checked: bool })
  }

  handleTouchStart(e) {
    this.touchStartX.current = e.touches[0].clientX
    this.touchLastX.current = e.touches[0].clientX
    this.touchLastTime.current = e.timeStamp
  }

  handleTouchMove(e) {
    const touchX = e.touches[0].clientX
    this.touchLastX.current = touchX
    this.touchLastTime.current = e.timeStamp
  }

  handleTouchEnd(e, images, isCalMax) {
    const touchEndX = e.changedTouches[0].clientX
    const { shownImageIndex, showVideo } = this.state

    // Calculate swipe distance and velocity
    const swipeDistance = touchEndX - this.touchStartX.current
    const timeDelta = e.timeStamp - this.touchLastTime.current
    const swipeVelocity = timeDelta > 0 ? (touchEndX - this.touchLastX.current) / timeDelta : 0
    const minSwipeDistance = 50 // Minimum distance for a swipe to be registered
    const minSwipeVelocity = 0.3 // Minimum velocity for a swipe to be registered

    if (Math.abs(swipeDistance) > minSwipeDistance || Math.abs(swipeVelocity) > minSwipeVelocity) {
      // Swipe right - go to previous image
      if (swipeDistance > 0 || swipeVelocity > 0) {
        if (!isCalMax && showVideo) return this.setState({ showVideo: false }) // Stop the video if we're on the last image AND not calMax (the product video thumbnail is displayed AFTER the image array) -- this needs a better solution
        return this.setShownImageIndex(Math.max(0, shownImageIndex - 1))
      }

      // Swipe left - go to next image
      if (!isCalMax && shownImageIndex === images.length - 1)
        return this.setState({ showVideo: true }) // Start the video if we're on the last image AND not calMax -- this needs a better solution
      return this.setShownImageIndex(Math.min(images.length - 1, shownImageIndex + 1))
    }
  }

  async handleAddToCart(productInfo) {
    const {
      addToCart,
      store: { cart },
    } = this.context
    const { submitting, size, color, style, Cal10Offer, Cal15Offer } = this.state
    const {
      data: { returnGuarantee },
    } = this.props
    const {
      variants: [{ storefrontId: returnGuaranteeId }],
    } = returnGuarantee || { variants: [{ storefrontId: null }] }
    const variantId = productInfo.shopifyId
    const id = variantId.split('/').pop()
    const productId = productInfo.productId.split('/').pop()

    const pushToDataLayer = () => {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          currencyCode,
          add: {
            products: [
              {
                id,
                name: productInfo.name,
                category: 'Calendar',
                price: productInfo.price,
                quantity: 1,
                sku: productInfo.sku,
                productId,
              },
            ],
          },
        },
      })
    }
    if (!submitting) {
      this.setState({ submitting: true })
      Analytics.track(`Added Calendar to Cart`)
      const baseEvent = `Added ${size}in Cal`
      const message =
        size === 10 ? `${baseEvent} to Cart` : `${baseEvent} ${style} ${color} to Cart`
      Analytics.track(message)
      const items = [{ variantId, quantity: 1 }]
      let frameBlackShopifyId
      let calendar10ShopifyId
      let calendar15ShopifyId

      if (!IS_FOREIGN_COUNTRY) {
        ;({
          pageContext: {
            frameBlack: {
              data: {
                shopifyProduct: { variants: [{ shopifyId: frameBlackShopifyId } = {}] = [] } = {},
              } = {},
            } = {},
            calendar10: {
              data: {
                shopifyProduct: { variants: [{ shopifyId: calendar10ShopifyId } = {}] = [] } = {},
              } = {},
            } = {},
            calendar15: {
              data: {
                shopifyProduct: { variants: [{ shopifyId: calendar15ShopifyId } = {}] = [] } = {},
              } = {},
            } = {},
          },
        } = this.props)
      } else if (IS_FOREIGN_COUNTRY) {
        ;({
          pageContext: {
            frameBlack: {
              data: {
                shopifyProduct: { variants: [{ shopifyId: frameBlackShopifyId } = {}] = [] } = {},
              } = {},
            } = {},
          },
        } = this.props)
      }
      const { checked, selected } = this.state
      if (Cal10Offer) {
        items.push({ variantId: calendar10ShopifyId, quantity: 1 })
        Analytics.track(`Added Calendar 10" BOGO Deal to Cart`)
      }
      if (Cal15Offer) {
        items.push({ variantId: calendar15ShopifyId, quantity: 1 })
        Analytics.track(`Added Calendar 15" BOGO Deal to Cart`)
      }
      if (checked) {
        items.push({ variantId: frameBlackShopifyId, quantity: 1 })
        Analytics.track(`Added Frame BOGO Deal to Cart`)
      }
      if (selected && size === 27) {
        items.push({ variantId: CA_CALENDAR_FIFTEEN, quantity: 1 })
        Analytics.track(`Added Calendar 15" Cross Sell to Cart`)
      }
      const resp = await addToCart(addReturnGuarantee(items, cart, returnGuaranteeId))
      if (resp && resp.error) {
        this.setSubmitting(false)
        alert(resp.error)
      } else {
        pushToDataLayer(variantId, productInfo)
        navigate('/cart/')
      }
    }
  }

  getProductInfo() {
    const { size, color, style, isPlusProduct } = this.state
    const { pageContext } = this.props
    const isCalMax = size === 27

    const name = isCalMax
      ? `Skylight Calendar Max (${style}/${color})`
      : `The Skylight Calendar${size === 15 ? ` 15"` : ''}`

    const getProductKey = (plusProduct = isPlusProduct) => {
      let key = `${size}.${plusProduct ? 'isPlusProduct' : 'withoutPlus'}`
      if (size !== 10) {
        key = `${key}.${style}.${color}`
      }
      return key
    }
    const { data } = this.props
    const {
      calendar10,
      calendar15,
      calMaxShadowBoxNaturalAluminum,
      calMaxShadowBoxCharcoal,
      calMaxClassicBlack,
      calMaxClassicWhite,
      calendarWithPlus,
      calendarWith15Plus,
      calendar15Charcoal,
      calendar15CharcoalWithPlus,
      calMaxShadowBoxNaturalAluminumWithPlus,
      calMaxShadowBoxCharcoalWithPlus,
      calMaxClassicBlackWithPlus,
      calMaxClassicWhiteWithPlus,
    } = pageContext
    let { product } = data

    if (!product) {
      product = calMaxClassicWhite.data.shopifyProduct
    }

    const { images } = product

    const productMap = {
      '15.withoutPlus.Classic.White': calendar15.data.shopifyProduct,
      '15.withoutPlus.Shadow Box.Charcoal': calendar15Charcoal.data.shopifyProduct,
      '10.withoutPlus': calendar10.data.shopifyProduct,
      '27.withoutPlus.Classic.White': calMaxClassicWhite.data.shopifyProduct,
      '27.withoutPlus.Shadow Box.Natural Aluminum':
        calMaxShadowBoxNaturalAluminum.data.shopifyProduct,
      '27.withoutPlus.Classic.Black': calMaxClassicBlack.data.shopifyProduct,
      '27.withoutPlus.Shadow Box.Charcoal': calMaxShadowBoxCharcoal.data.shopifyProduct,
      '15.isPlusProduct.Classic.White': calendarWith15Plus.data.shopifyProduct,
      '15.isPlusProduct.Shadow Box.Charcoal': calendar15CharcoalWithPlus.data.shopifyProduct,
      '10.isPlusProduct': calendarWithPlus.data.shopifyProduct,
      '27.isPlusProduct.Classic.White': calMaxClassicWhiteWithPlus.data.shopifyProduct,
      '27.isPlusProduct.Shadow Box.Natural Aluminum':
        calMaxShadowBoxNaturalAluminumWithPlus.data.shopifyProduct,
      '27.isPlusProduct.Classic.Black': calMaxClassicBlackWithPlus.data.shopifyProduct,
      '27.isPlusProduct.Shadow Box.Charcoal': calMaxShadowBoxCharcoalWithPlus.data.shopifyProduct,
    }

    const regularKey = getProductKey(false)
    const plusKey = getProductKey(true)

    const productDescription = productMap[getProductKey()]

    const regularProduct = productMap[regularKey]
    const plusProduct = productMap[plusKey]

    const calProduct = regularProduct?.variants?.[0]
    const calPlusProduct = plusProduct?.variants?.[0]

    return {
      calendar: {
        ...calProduct,
        name,
        productId: regularProduct?.shopifyId || null,
        productDescription,
        images: regularProduct.images || images,
      },
      withPlus: {
        ...calPlusProduct,
        name: `${name} with Plus Plan`,
        productId: plusProduct?.shopifyId || null,
        productDescription,
        images: plusProduct.images || images,
      },
    }
  }

  setShowDropdown(showDropdown) {
    this.setState({ showDropdown })
  }

  setShownImageIndex(shownImageIndex) {
    this.setState({ shownImageIndex })
  }

  setDisplayToolTip(bool) {
    this.setState({ displayToolTip: bool })
  }

  // toggleSelected() {
  //   this.setState((prev) => ({ selected: !prev.selected }))
  // }

  updateMedia() {
    this.setState({ isMobile: window.innerWidth <= 768 })
  }

  trackProductView() {
    const { isPlusProduct } = this.state
    const productInfo = this.getProductInfo()
    const selectedProductInfo = isPlusProduct ? productInfo.withPlus : productInfo.calendar
    const variantId = selectedProductInfo.shopifyId.split('/').pop()
    const productId = selectedProductInfo.productId.split('/').pop()
    const productDetails = {
      id: variantId,
      name: selectedProductInfo.name,
      category: 'Calendar',
      price: selectedProductInfo.price,
      quantity: 1,
      sku: selectedProductInfo.sku,
      productId,
    }
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'viewItem',
      ecommerce: {
        currencyCode,
        add: {
          products: [productDetails],
        },
      },
    })
  }

  checkIfScrollable() {
    const scrollableElement = this.scrollableThumbnailContainerRef.current
    if (scrollableElement) {
      const newisScrollable = scrollableElement.scrollWidth > scrollableElement.clientWidth
      const { isScrollable } = this.state
      if (newisScrollable !== isScrollable) {
        this.setState({ isScrollable: newisScrollable })
      }
    }
  }

  scrollLeft() {
    if (this.scrollableThumbnailContainerRef.current) {
      this.scrollableThumbnailContainerRef.current.scrollBy({ left: -130, behavior: 'smooth' })
    }
  }

  scrollRight() {
    if (this.scrollableThumbnailContainerRef.current) {
      this.scrollableThumbnailContainerRef.current.scrollBy({ left: 130, behavior: 'smooth' })
    }
  }

  render() {
    const {
      shownImageIndex,
      showVideo,
      largerDevice,
      isPlusProduct,
      showDropdown,
      size,
      color,
      style,
      isScrollable,
      displayToolTip,
      isMobile,
      // selected,
    } = this.state
    const { data, t, pageContext } = this.props
    const {
      radioFull,
      radioEmpty,
      dropdownicon,
      dropupicon,
      customizedScreensaver,
      mealPlanning,
      magicImport,
      calMaxClassicBlackIcon,
      calMaxClassicWhiteIcon,
      calMax15ClassicWhiteIcon,
      calMaxShadowBoxAluminumIcon,
      calMaxShadowBoxCharcoalIcon,
      // btsBadge,
      contentfulCTAOverrides,
      contentfulCalPrice,
      backorder,
      calMaxOgImage,
      cal15OgImage,
    } = data

    const {
      calMaxShadowBoxNaturalAluminum,
      calMaxClassicWhite,
      calMaxShadowBoxNaturalAluminumWithPlus,
      calMaxClassicWhiteWithPlus,
      calendar15CharcoalWithPlus,
      calendar15Charcoal,
      calendar15,
      calendarWith15Plus,
    } = pageContext

    const { badge } = data
    let { product } = data
    if (!product) {
      product = IS_FOREIGN_COUNTRY
        ? calMaxClassicWhite.data.shopifyProduct
        : calMaxShadowBoxNaturalAluminum.data.shopifyProduct
    }
    const productInfo = this.getProductInfo()

    const { images } = productInfo.calendar
    const shownImage = productInfo.calendar.images[shownImageIndex]

    const isCalMax = size === 27
    const selectedVariant = `${style} ${color}`.replaceAll(' ', '_').toLowerCase()
    const selectedVariantContent = backorder[selectedVariant]
    const isSelectedOnBackorder =
      backorder.onBackorder &&
      backorder.backorderVariants?.includes(selectedVariant) &&
      !IS_FOREIGN_COUNTRY

    const calPlusFeatureIcons = { mealPlanning, customizedScreensaver, magicImport }
    const badgeList = badge.edges[0].node.showPdpBadge
    const includesSizeAndCalendar = (list) => {
      const searchString = `${size}" Calendar`
      return list.some((item) => item.includes(searchString))
    }
    const lang = defaultLanguage.replace('-', '_')

    const badgeData = badge.edges[0].node
    const shownBadge =
      shownImageIndex < badgeData.usaCalendarBadge.length
        ? badgeData.usaCalendarBadge[shownImageIndex]
        : null

    // if (IN_UK && size === 15) {
    //   shownBadge = btsBadge.childImageSharp
    // }

    const displayBadge = shownBadge && includesSizeAndCalendar(badgeList)

    const ctaDetails = GetCtaDetails(lang, true, size, contentfulCTAOverrides.edges[0].node, color)
    const { isPreorder, CTA_VALUE, isOutOfStock } = ctaDetails

    const {
      en_gb_show_override_prices,
      en_gb_cal_15_with_plus_original_price,
      en_gb_cal_15_without_plus_original_price,
      en_gb_cal_15_with_plus_discounted_price,
      en_gb_cal_15_without_plus_discounted_price,
      en_ca_show_override_prices,
      en_ca_cal_15_with_plus_original_price,
      en_ca_cal_15_without_plus_original_price,
      en_ca_cal_15_with_plus_discounted_price,
      en_ca_cal_15_without_plus_discounted_price,
      en_au_show_override_prices,
      en_au_cal_15_with_plus_original_price,
      en_au_cal_15_without_plus_original_price,
      en_au_cal_15_with_plus_discounted_price,
      en_au_cal_15_without_plus_discounted_price,
    } = contentfulCalPrice.edges[0].node
    const overRidePrices = {
      'en-gb': {
        showOverridePrices: en_gb_show_override_prices,
        ogwithPlusPrice: en_gb_cal_15_with_plus_original_price,
        ogwithPlusDiscountedPrice: en_gb_cal_15_with_plus_discounted_price,
        ogwithoutPlusPrice: en_gb_cal_15_without_plus_original_price,
        ogwithoutPlusDiscountedPrice: en_gb_cal_15_without_plus_discounted_price,
      },
      'en-ca': {
        showOverridePrices: en_ca_show_override_prices,
        ogwithPlusPrice: en_ca_cal_15_with_plus_original_price,
        ogwithPlusDiscountedPrice: en_ca_cal_15_with_plus_discounted_price,
        ogwithoutPlusPrice: en_ca_cal_15_without_plus_original_price,
        ogwithoutPlusDiscountedPrice: en_ca_cal_15_without_plus_discounted_price,
      },
      'en-au': {
        showOverridePrices: en_au_show_override_prices,
        ogwithPlusPrice: en_au_cal_15_with_plus_original_price,
        ogwithPlusDiscountedPrice: en_au_cal_15_with_plus_discounted_price,
        ogwithoutPlusPrice: en_au_cal_15_without_plus_original_price,
        ogwithoutPlusDiscountedPrice: en_au_cal_15_without_plus_discounted_price,
      },
      // en: {
      //   showOverridePrices: true,
      //   ogwithPlusPrice:
      //     size === 10 ? 169.99 : size === 15 ? 299.99 : style === 'Classic' ? 599.99 : 629.99,
      //   ogwithPlusDiscountedPrice:
      //     size === 10 ? 109.99 : size === 15 ? 239.99 : style === 'Classic' ? 529.99 : 559.99,
      //   ogwithoutPlusPrice:
      //     size === 10 ? 169.99 : size === 15 ? 299.99 : style === 'Classic' ? 599.99 : 629.99,
      //   ogwithoutPlusDiscountedPrice:
      //     size === 10 ? 129.99 : size === 15 ? 259.99 : style === 'Classic' ? 559.99 : 589.99,
      // },
    }
    const showBfDesign =
      (overRidePrices[LOCALIZATION]?.showOverridePrices && size === 15 && IS_FOREIGN_COUNTRY) ||
      false

    const CAL_15_EVENT_LABEL = [
      '1st',
      '2nd',
      '3rd',
      '4th',
      '5th',
      '6th',
      '7th',
      '8th',
      '9th',
      '10th',
      '11th',
      '12th',
    ]

    const PLUS_PRICE = {
      en: '$79',
      'en-gb': '£60',
      'en-ca': '$109.99',
      'en-au': '$124.99',
    }

    const IS_VIPBTS = false

    let rawAmount = productInfo.calendar.price / 4
    if (showBfDesign) {
      rawAmount = overRidePrices[LOCALIZATION]?.ogwithoutPlusDiscountedPrice / 4
    }

    const SHOP_PAY_AMOUNT = FormattedCurrency((Math.floor(rawAmount * 100) / 100).toFixed(2))
    // Showing design when cal 2 is available on the website for USA
    // const showStyleOptions = isCalMax || (!IS_FOREIGN_COUNTRY && size === 15)
    const showStyleOptions = isCalMax

    // Use size to trigger descriptions - can be extended to use product handle for more granular control
    const metaMap = {
      27: {
        title: 'Skylight Calendar Max | 27 Inch Smart Family Calendar | Product Details',
        description:
          'Skylight Calendar Max is a 27” smart, all-in-one, touchscreen calendar that simplifies busy households. It displays your family’s events, chore charts, meal planning, lists, & more all on one screen.',
        imagePath: calMaxOgImage.childImageSharp.gatsbyImageData.images.fallback.src,
        canonical: '/products/skylight-calendar-max/',
      },

      15: {
        title: 'Skylight Calendar | 15 Inch Smart Family Calendar | Product Details',
        description:
          'Skylight Calendar is a smart, touchscreen wall calendar that keeps track of your family’s schedule, chores, meal prep, and more — all in one place! Staying on top of everything just got a whole lot easier.',
        imagePath: cal15OgImage.childImageSharp.gatsbyImageData.images.fallback.src,
      },

      fallback: {
        title: `Skylight Calendar | Smart Family Calendar`,
        description:
          "Skylight Calendar is a smart, touchscreen wall calendar that displays your family's important events and chores.",
        imagePath: product.images[0].gatsbyImageData.images.fallback.src,
        canonical: CAL_BUY_LINK,
      },
    }

    const activeSEO = { ...metaMap.fallback, ...metaMap[size] }

    return (
      <>
        <SEO
          title={t(activeSEO.title)}
          excludeTitleTagPrefix
          description={activeSEO.description}
          imagePath={activeSEO.imagePath}
          canonicalPath={activeSEO.canonical}
          hrefLangPathOverrides={isCalMax ? {} : HREF_LANG_PATH_OVERRIDES}
          path={`/products/${product.handle}/`}
        />
        {displayToolTip && (
          <ToolTip
            selectedCalendar={isPlusProduct ? productInfo.withPlus : productInfo.calendar}
            selectedCalendarProductId={
              isPlusProduct
                ? productInfo.withPlus.productId.split('/').pop()
                : productInfo.calendar.productId.split('/').pop()
            }
            setDisplayToolTip={this.setDisplayToolTip}
            displayAddToCart
            onClick={() => Analytics.track('Clicked Tooltip on PDP CTA')}
            size={size}
            style={style}
            color={color}
            amount={SHOP_PAY_AMOUNT}
          />
        )}
        <Section>
          <Container>
            <Grid>
              <ProductGridLeft>
                {showVideo === true ? (
                  <VideoContainer>
                    <video width="100%" controls autoPlay>
                      <source
                        src="https://cdn.shopify.com/videos/c/o/v/19104b6349884965b950e58829a9ddb4.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </VideoContainer>
                ) : (
                  <ProductImage
                    image={shownImage.gatsbyImageData}
                    key={`${size}-${color}-${isPlusProduct}-${shownImage.id}`}
                    alt={product.title}
                    className={largerDevice ? 'zoom' : 'standard'}
                    onTouchStart={this.handleTouchStart}
                    onTouchMove={this.handleTouchMove}
                    onTouchEnd={(e) => this.handleTouchEnd(e, images, isCalMax)}
                  />
                )}
                {displayBadge && (
                  <GiftModeImage>
                    <GatsbyImage
                      image={shownBadge.gatsbyImageData}
                      alt="Calendar Product Page Badge"
                    />
                  </GiftModeImage>
                )}
                <ArrowContainer>
                  {isScrollable && (
                    <LeftArrow type="button" onClick={() => this.scrollLeft()}>
                      ‹
                    </LeftArrow>
                  )}
                  <ThumbnailRow
                    ref={this.scrollableThumbnailContainerRef}
                    start={isScrollable.toString()}
                  >
                    {images.map((image, index) => (
                      <ThumbnailButton
                        key={`thumbnail-${size}-${color}-${isPlusProduct}-${image.id}-${index}`}
                        type="button"
                        onClick={() => {
                          this.setShownImageIndex(index)
                          this.setState({ showVideo: false })
                          if (!IS_FOREIGN_COUNTRY && size === 15)
                            Analytics.track(
                              `Viewed 15in Cal ${CAL_15_EVENT_LABEL[index]} Image Product Page`
                            )
                        }}
                      >
                        <Thumbnail
                          $calendar
                          image={image.gatsbyImageData}
                          alt={`${product.title} Thumbnail ${index}`}
                        />
                      </ThumbnailButton>
                    ))}
                    {!isCalMax && (
                      <ThumbnailButton
                        type="button"
                        onClick={() => {
                          this.setState({ showVideo: true })
                          if (!IS_FOREIGN_COUNTRY && size === 15)
                            Analytics.track('Viewed 15in Cal Video Product Page')
                        }}
                      >
                        <ThumbnailVideo>
                          <CalendarVideoThumbnail
                            src={calProductVideo}
                            alt="Introducing Skylight Calendar"
                          />
                        </ThumbnailVideo>
                      </ThumbnailButton>
                    )}
                  </ThumbnailRow>
                  {isScrollable && (
                    <RightArrow type="button" onClick={() => this.scrollRight()}>
                      ›
                    </RightArrow>
                  )}
                </ArrowContainer>
              </ProductGridLeft>
              <ProductGridRight>
                <>
                  <Centered>
                    <YotpoStars color={theme.gold} productId="6863425175604" />
                  </Centered>
                  <HeaderContainer>
                    <Header>
                      <Trans>{isCalMax ? 'Calendar Max' : 'The Skylight Calendar'}</Trans>
                    </Header>
                    {isCalMax && isSelectedOnBackorder && <Badge fast>ON BACKORDER</Badge>}
                  </HeaderContainer>
                  <CustomizationOption>
                    <Subheader>
                      <Trans>Select your Calendar size</Trans>
                    </Subheader>
                    <DropDownContainer onClick={() => this.setShowDropdown(!showDropdown)}>
                      {/* <DropDownLabel>
                          <>
                            {PRODUCT_DROPDOWN_LABELS[size].label}
                            {isCalMax && <Bubble blue>SELLING FAST</Bubble>}
                          </>
                        </DropDownLabel> */}
                      <DropDownLabel>
                        {IS_VIPBTS ? (
                          <>
                            <p>
                              {isMobile
                                ? PRODUCT_DROPDOWN_LABELS[size].label.replace('Calendar', 'Cal')
                                : PRODUCT_DROPDOWN_LABELS[size].label}
                            </p>
                            <div>
                              {isCalMax ? (
                                <Bubble blue>SELLING FAST</Bubble>
                              ) : (
                                <>
                                  <Bubble>{CAL_SIZE_PRICING[size].bubble}</Bubble>
                                  <Strikethough>
                                    {FormattedCurrency(CAL_SIZE_PRICING[size].regularPrice)}
                                  </Strikethough>
                                  <Price
                                    color={
                                      CAL_SIZE_PRICING[size]?.discountedPrice
                                        ? 'coral'
                                        : 'textRegular'
                                    }
                                  >
                                    {FormattedCurrency(CAL_SIZE_PRICING[size]?.discountedPrice)}
                                  </Price>
                                </>
                              )}
                            </div>
                          </>
                        ) : (
                          <>
                            {IS_VIPBTS ? (
                              <>
                                <p>
                                  {isMobile
                                    ? PRODUCT_DROPDOWN_LABELS[size].label.replace('Calendar', 'Cal')
                                    : PRODUCT_DROPDOWN_LABELS[size].label}
                                </p>
                                <div>
                                  {isCalMax ? (
                                    <Bubble blue>SELLING FAST</Bubble>
                                  ) : (
                                    <>
                                      <Bubble>{CAL_SIZE_PRICING[size].bubble}</Bubble>
                                      <Strikethough>
                                        {FormattedCurrency(CAL_SIZE_PRICING[size].regularPrice)}
                                      </Strikethough>
                                      <Price
                                        color={
                                          CAL_SIZE_PRICING[size]?.discountedPrice
                                            ? 'coral'
                                            : 'textRegular'
                                        }
                                      >
                                        {FormattedCurrency(CAL_SIZE_PRICING[size]?.discountedPrice)}
                                      </Price>
                                    </>
                                  )}
                                </div>
                              </>
                            ) : (
                              <p>{PRODUCT_DROPDOWN_LABELS[size].label}</p>
                            )}
                          </>
                        )}
                      </DropDownLabel>
                      <DropDownImageContainer>
                        <DropDownIconContainer>
                          <GatsbyImage
                            image={
                              showDropdown
                                ? dropupicon.childImageSharp.gatsbyImageData
                                : dropdownicon.childImageSharp.gatsbyImageData
                            }
                            alt="Drop Down Arrow"
                          />
                        </DropDownIconContainer>
                      </DropDownImageContainer>
                    </DropDownContainer>
                  </CustomizationOption>
                  {showDropdown && (
                    <DropDownContainerOptions margin>
                      {Object.entries(PRODUCT_DROPDOWN_LABELS).map(([key, details]) => {
                        if (parseInt(size, 10) !== parseInt(key, 10)) {
                          return (
                            <DropDownLabelOption
                              key={`${size}-${key}-dropdown`}
                              onClick={() => {
                                this.handleSizeSelection(parseInt(key, 10))
                                this.setShowDropdown(false)
                                this.setShownImageIndex(0)
                                Analytics.track(
                                  `Viewed ${parseInt(key, 10)}in Cal Toggle Product Page`
                                )
                              }}
                            >
                              {/* <>
                                <p>{details.label}</p>
                                {key === '27' && (
                                  <div>
                                    <Bubble blue>SELLING FAST</Bubble>
                                  </div>
                                )}
                              </> */}
                              {IS_VIPBTS ? (
                                <>
                                  <p>
                                    {' '}
                                    {isMobile
                                      ? PRODUCT_DROPDOWN_LABELS[key].label.replace(
                                          'Calendar',
                                          'Cal'
                                        )
                                      : PRODUCT_DROPDOWN_LABELS[key].label}
                                  </p>
                                  <div>
                                    {key === '27' ? (
                                      <Bubble blue>SELLING FAST</Bubble>
                                    ) : (
                                      <>
                                        <Bubble>{CAL_SIZE_PRICING[key].bubble}</Bubble>
                                        <Strikethough>
                                          {FormattedCurrency(CAL_SIZE_PRICING[key].regularPrice)}
                                        </Strikethough>
                                        <Price
                                          color={
                                            CAL_SIZE_PRICING[key]?.discountedPrice
                                              ? 'coral'
                                              : 'textRegular'
                                          }
                                        >
                                          {FormattedCurrency(
                                            CAL_SIZE_PRICING[key]?.discountedPrice
                                          )}
                                        </Price>
                                      </>
                                    )}
                                  </div>
                                </>
                              ) : (
                                <p>{details.label}</p>
                              )}
                            </DropDownLabelOption>
                          )
                        }
                        return null
                      })}
                    </DropDownContainerOptions>
                  )}
                  {/* {IN_UK && size === 15 && <DiscountBanner max={size === 27} />} */}
                  {SHOW_BETTER_HELP_DESIGN && <BetterHelpBanner />}
                  {showStyleOptions && (
                    <>
                      {isSelectedOnBackorder && (
                        <Backorder color={backorder.color} content={selectedVariantContent} />
                      )}
                      <SubLabel>
                        <Trans>Select a style</Trans>
                      </SubLabel>
                      <StyleOptionsContainer
                        reverse={IS_FOREIGN_COUNTRY || (!IS_FOREIGN_COUNTRY && size === 15)}
                      >
                        <SelectionOption
                          oos={IS_FOREIGN_COUNTRY}
                          selected={style === 'Shadow Box'}
                          onClick={() => {
                            this.handleStyleSelection('Shadow Box')
                            this.setShownImageIndex(0)
                          }}
                        >
                          <CalMaxIcon>
                            <GatsbyImage
                              image={
                                color === 'Natural Aluminum' || IS_FOREIGN_COUNTRY
                                  ? calMaxShadowBoxAluminumIcon.childImageSharp.gatsbyImageData
                                  : calMaxShadowBoxCharcoalIcon.childImageSharp.gatsbyImageData
                              }
                              alt="Save with Plus"
                            />
                            {IS_FOREIGN_COUNTRY && <ComingSoon>Coming Soon</ComingSoon>}
                          </CalMaxIcon>
                          <StyleText>Shadow Box</StyleText>
                          {/* {IS_VIPBTS ? (
                            <StyleOptionsContainer>
                              <StyleText blue isDiscounted>
                                $629.99
                              </StyleText>
                              <StyleText red blue>
                                {isPlusProduct ? '$559.99' : '$589.99'}
                              </StyleText>
                            </StyleOptionsContainer>
                          ) : ( */}
                          <StyleText blue>
                            <Trans>
                              {style === 'Shadow Box' && isPlusProduct && size === 27
                                ? FormattedCurrency(productInfo.withPlus.price)
                                : style === 'Shadow Box' && size === 27
                                ? FormattedCurrency(productInfo.calendar.price)
                                : size === 27
                                ? FormattedCurrency(
                                    calMaxShadowBoxNaturalAluminumWithPlus.data.shopifyProduct
                                      .variants[0].price
                                  )
                                : isPlusProduct
                                ? FormattedCurrency(
                                    calendar15CharcoalWithPlus.data.shopifyProduct.variants[0].price
                                  )
                                : calendar15Charcoal.data.shopifyProduct.variants[0].price}
                            </Trans>
                          </StyleText>
                          {/* )} */}
                          <StyleDescription>
                            {size === 15
                              ? 'Modern & versatile with an aluminum snap frame.'
                              : `${
                                  IS_FOREIGN_COUNTRY ? '' : 'Our favorite. '
                                } Encased in 100% aluminum frame.`}
                          </StyleDescription>
                          {size === 15 && <LimitedAvailable>Limited Availability</LimitedAvailable>}
                        </SelectionOption>
                        <SelectionOption
                          selected={style === 'Classic'}
                          onClick={() => {
                            this.handleStyleSelection('Classic')
                            this.setShownImageIndex(0)
                          }}
                        >
                          <CalMaxIcon>
                            <GatsbyImage
                              image={
                                color === 'Black'
                                  ? calMaxClassicBlackIcon.childImageSharp.gatsbyImageData
                                  : size === 15
                                  ? calMax15ClassicWhiteIcon.childImageSharp.gatsbyImageData
                                  : calMaxClassicWhiteIcon.childImageSharp.gatsbyImageData
                              }
                              alt="Save with Plus"
                            />
                          </CalMaxIcon>
                          <StyleText>Classic</StyleText>
                          {/* {IS_VIPBTS ? (
                            <StyleOptionsContainer>
                              <StyleText blue isDiscounted>
                                $599.99
                              </StyleText>
                              <StyleText red blue>
                                {isPlusProduct ? '$529.99' : '$559.99'}
                              </StyleText>
                            </StyleOptionsContainer>
                          ) : ( */}
                          <StyleText blue>
                            <Trans>
                              {style === 'Classic' && isPlusProduct && size === 27
                                ? FormattedCurrency(productInfo.withPlus.price)
                                : style === 'Classic' && size === 27
                                ? FormattedCurrency(productInfo.calendar.price)
                                : size === 27
                                ? FormattedCurrency(
                                    calMaxClassicWhiteWithPlus.data.shopifyProduct.variants[0].price
                                  )
                                : isPlusProduct
                                ? FormattedCurrency(
                                    calendarWith15Plus.data.shopifyProduct.variants[0].price
                                  )
                                : FormattedCurrency(
                                    calendar15.data.shopifyProduct.variants[0].price
                                  )}
                            </Trans>
                          </StyleText>
                          {/* )} */}
                          <StyleDescription>
                            {size === 15
                              ? 'Our best seller, in a sleek, contemporary frame.'
                              : 'Timeless and contemporary plastic frame.'}
                          </StyleDescription>
                        </SelectionOption>
                      </StyleOptionsContainer>
                      {!IS_FOREIGN_COUNTRY && (
                        <SubLabel>
                          <Trans>Select a {style === 'Classic' ? 'color' : 'finish'}</Trans>
                        </SubLabel>
                      )}
                      <FrameProductOptions basend>
                        {style === 'Classic' ? (
                          <>
                            <ColorSelectionItem
                              variant="White"
                              onSelectColor={() => {
                                this.handleColorSelection('White')
                                this.setShownImageIndex(0)
                              }}
                              isOutOfStock={
                                contentfulCTAOverrides.edges[0].node.en_27_white_calendar ===
                                'Out of Stock'
                              }
                              isSelected={color === 'White'}
                            />
                            {!IS_FOREIGN_COUNTRY && size === 27 && (
                              <ColorSelectionItem
                                variant="Black"
                                onSelectColor={() => {
                                  this.handleColorSelection('Black')
                                  this.setShownImageIndex(0)
                                }}
                                isOutOfStock={
                                  contentfulCTAOverrides.edges[0].node.en_27_black_calendar ===
                                  'Out of Stock'
                                }
                                isSelected={color === 'Black'}
                              />
                            )}
                          </>
                        ) : (
                          <>
                            {size === 27 && (
                              <ColorSelectionItem
                                variant="Natural Aluminum"
                                onSelectColor={() => {
                                  this.handleColorSelection('Natural Aluminum')
                                  this.setShownImageIndex(0)
                                }}
                                isOutOfStock={
                                  contentfulCTAOverrides.edges[0].node.en_27_aluminum_calendar ===
                                  'Out of Stock'
                                }
                                isSelected={color === 'Natural Aluminum'}
                              />
                            )}
                            {!IS_FOREIGN_COUNTRY && (
                              <ColorSelectionItem
                                variant="Charcoal"
                                onSelectColor={() => {
                                  this.handleColorSelection('Charcoal')
                                  this.setShownImageIndex(0)
                                }}
                                isOutOfStock={
                                  contentfulCTAOverrides.edges[0].node.en_27_charcoal_calendar ===
                                  'Out of Stock'
                                }
                                isSelected={color === 'Charcoal'}
                              />
                            )}
                          </>
                        )}
                      </FrameProductOptions>
                    </>
                  )}
                  {/* {IN_CA && size === 27 && (
                    <Card selected={selected} onClick={this.toggleSelected}>
                      <Content>
                        <SaleBadge>$100 OFF</SaleBadge>
                        <Checkbox type="checkbox" checked={selected} />
                        <Title>Add on a 15" Calendar</Title>
                      </Content>
                      <Content>
                        <Description>
                          Buy Calendar Max with Plus and get a 15" Calendar for $100 off
                        </Description>
                        <PriceRow>
                          <WasPrice>
                            Was: <strike>$449.00</strike>
                          </WasPrice>
                          <NowPrice>Now: $349.00</NowPrice>
                        </PriceRow>
                      </Content>
                    </Card>
                  )} */}
                  <PickPriceContainer topMargin={isCalMax}>
                    <Subheader>
                      <Trans>
                        {showBfDesign ? 'On Sale for a Limited Time' : 'Pick your price'}
                      </Trans>
                    </Subheader>
                    {!isPlusProduct ? (
                      <>
                        <ProductSelectionBoxWrapper>
                          <MostPopular>
                            <Trans>Most Popular</Trans>
                          </MostPopular>
                          <ClickableProductSelectionBox
                            style={{ marginTop: -16 }}
                            onClick={() => {
                              this.handlePlusProduct(true)
                              this.setShownImageIndex(0)
                            }}
                          >
                            <ProductSelectionHeaderRow>
                              <ProductSelectionHeader>
                                <RadioIconContainer>
                                  <GatsbyImage
                                    image={radioEmpty.childImageSharp.gatsbyImageData}
                                    alt="Save with Plus"
                                  />
                                </RadioIconContainer>
                                {showBfDesign ? (
                                  <SaveInfo calendar>Save even more with Plus</SaveInfo>
                                ) : (
                                  <SaveInfo calendar>
                                    <Trans
                                      i18nKey="Save with Plus Plan"
                                      values={{
                                        priceSaving:
                                          productInfo.calendar.price - productInfo.withPlus.price,
                                      }}
                                    >
                                      Save {productInfo.calendar.price - productInfo.withPlus.price}{' '}
                                      with Plus Plan
                                    </Trans>
                                  </SaveInfo>
                                )}
                              </ProductSelectionHeader>
                              <PriceAndExplainerContainer>
                                {showBfDesign ? (
                                  <ClickableProductSelectionPricePoint>
                                    <>
                                      <strike>
                                        {FormattedCurrency(
                                          overRidePrices[LOCALIZATION].ogwithPlusPrice
                                        )}
                                      </strike>{' '}
                                      {FormattedCurrency(
                                        overRidePrices[LOCALIZATION].ogwithPlusDiscountedPrice
                                      )}
                                    </>
                                  </ClickableProductSelectionPricePoint>
                                ) : (
                                  <ClickableProductSelectionPricePoint>
                                    <>
                                      <strike>
                                        {FormattedCurrency(productInfo.calendar.price)}
                                      </strike>{' '}
                                      {FormattedCurrency(productInfo.withPlus.price)}
                                    </>
                                  </ClickableProductSelectionPricePoint>
                                )}
                              </PriceAndExplainerContainer>
                            </ProductSelectionHeaderRow>
                          </ClickableProductSelectionBox>
                        </ProductSelectionBoxWrapper>
                        <ProductSelectionBox ref={this.noplusSelectionRef}>
                          <ProductSelectionHeaderRow>
                            <ProductSelectionHeader>
                              <RadioIconContainer>
                                <GatsbyImage
                                  image={radioFull.childImageSharp.gatsbyImageData}
                                  alt="Save with Plus"
                                />
                              </RadioIconContainer>
                              <PlanHeading>
                                <Trans>Purchase without Plus</Trans>
                              </PlanHeading>
                            </ProductSelectionHeader>
                            <PriceAndExplainerContainer>
                              <ProductSelectionPricePoint>
                                {showBfDesign ? (
                                  <ProductSelectionPricePoint>
                                    <>
                                      <strike>
                                        {FormattedCurrency(
                                          overRidePrices[LOCALIZATION].ogwithoutPlusPrice
                                        )}
                                      </strike>{' '}
                                      {FormattedCurrency(
                                        overRidePrices[LOCALIZATION].ogwithoutPlusDiscountedPrice
                                      )}
                                    </>
                                  </ProductSelectionPricePoint>
                                ) : (
                                  <Trans>{FormattedCurrency(productInfo.calendar.price)}</Trans>
                                )}
                              </ProductSelectionPricePoint>
                              {!IS_FOREIGN_COUNTRY ? (
                                <ShopPay
                                  onTooltipClick={() => this.setDisplayToolTip(true)}
                                  size={size}
                                  style={style}
                                  amount={SHOP_PAY_AMOUNT}
                                />
                              ) : (
                                <OneTimePurchase>
                                  <Trans>One-Time Purchase</Trans>
                                </OneTimePurchase>
                              )}
                            </PriceAndExplainerContainer>
                          </ProductSelectionHeaderRow>
                          <p>
                            <Trans>
                              Skip the Plus Plan and pay more for your Calendar. Without Plus:
                            </Trans>
                          </p>
                          <ul>
                            <li>
                              <Trans>
                                You can still use all of Calendar's other features for free forever.
                              </Trans>
                            </li>
                            <li>
                              <Trans>
                                You will not be able to display photos on your Calendar or use Magic
                                Import or Meal Planning.
                              </Trans>
                            </li>
                          </ul>
                          <AddToCartButton
                            label={t(CTA_VALUE)}
                            // adding={submitting}
                            oos={isOutOfStock}
                            handleClick={() => this.handleAddToCart(productInfo.calendar)}
                          />
                        </ProductSelectionBox>
                      </>
                    ) : (
                      <>
                        <ProductSelectionBoxWrapper>
                          <MostPopular>
                            <Trans>Most Popular</Trans>
                          </MostPopular>
                          <ProductSelectionBox style={{ marginTop: -16 }}>
                            <ProductSelectionHeaderRow>
                              <ProductSelectionHeader>
                                <RadioIconContainer>
                                  <GatsbyImage
                                    image={radioFull.childImageSharp.gatsbyImageData}
                                    alt="Save with Plus"
                                  />
                                </RadioIconContainer>
                                {showBfDesign ? (
                                  <SaveInfo calendar>Save even more with Plus</SaveInfo>
                                ) : (
                                  <SaveInfo calendar>
                                    <Trans
                                      i18nKey="Save with Plus Plan"
                                      values={{
                                        priceSaving:
                                          productInfo.calendar.price - productInfo.withPlus.price,
                                      }}
                                    >
                                      Save $
                                      {productInfo.calendar.price - productInfo.withPlus.price} with
                                      Plus Plan
                                    </Trans>
                                  </SaveInfo>
                                )}
                              </ProductSelectionHeader>
                              <PriceAndExplainerContainer>
                                {showBfDesign ? (
                                  <ProductSelectionPricePoint>
                                    <>
                                      <strike>
                                        {FormattedCurrency(
                                          overRidePrices[LOCALIZATION].ogwithPlusPrice
                                        )}
                                      </strike>{' '}
                                      {FormattedCurrency(
                                        overRidePrices[LOCALIZATION].ogwithPlusDiscountedPrice
                                      )}
                                    </>
                                  </ProductSelectionPricePoint>
                                ) : (
                                  <ProductSelectionPricePoint>
                                    <>
                                      <strike>
                                        {FormattedCurrency(productInfo.calendar.price)}
                                      </strike>{' '}
                                      {FormattedCurrency(productInfo.withPlus.price)}
                                    </>
                                  </ProductSelectionPricePoint>
                                )}
                                <OneTimePurchase cal>
                                  {size === 27 ? (
                                    <Trans>
                                      {IS_VIPBTS
                                        ? FormattedCurrency(
                                            overRidePrices[LOCALIZATION].ogwithPlusDiscountedPrice
                                          )
                                        : FormattedCurrency(productInfo.withPlus.price)}{' '}
                                      One-Time Purchase + One Free Month Of Plus
                                    </Trans>
                                  ) : (
                                    <>
                                      {showBfDesign ? (
                                        <Trans>
                                          {FormattedCurrency(
                                            overRidePrices[LOCALIZATION].ogwithPlusDiscountedPrice
                                          )}{' '}
                                          One-Time Purchase + One Free Month Of Plus
                                        </Trans>
                                      ) : (
                                        <Trans>
                                          {FormattedCurrency(productInfo.withPlus.price)} One-Time
                                          Purchase + One Free Month Of Plus
                                        </Trans>
                                      )}
                                    </>
                                  )}
                                </OneTimePurchase>
                              </PriceAndExplainerContainer>
                            </ProductSelectionHeaderRow>
                            {size === 27 ? (
                              <PlusPlanIncludes underline>
                                <Trans>
                                  Get more with Calendar Plus ({PLUS_PRICE[LOCALIZATION]}/year)
                                </Trans>
                              </PlusPlanIncludes>
                            ) : (
                              <PlusPlanIncludes>Plus Plan Includes:</PlusPlanIncludes>
                            )}

                            <CalFeatureRow>
                              {Object.keys(CAL_PLUS_FEATURES).map((key) => {
                                const feature = CAL_PLUS_FEATURES[key]
                                const icon = calPlusFeatureIcons[key]
                                return (
                                  <CalFeature key={key}>
                                    <IconContainer>
                                      <GatsbyImage
                                        image={icon.childImageSharp.gatsbyImageData}
                                        alt={feature.heading}
                                      />
                                    </IconContainer>
                                    <CalFeatureHeading>{feature.heading}</CalFeatureHeading>
                                    <CalFeatureText>{feature.text}</CalFeatureText>
                                  </CalFeature>
                                )
                              })}
                            </CalFeatureRow>
                            {size === 27 ? (
                              <div />
                            ) : (
                              <p style={{ marginLeft: 0, textAlign: 'center' }}>
                                Your first month is free, then Plus is{' '}
                                <strong style={{ fontFamily: 'FilsonProBold' }}>
                                  {PLUS_PRICE[LOCALIZATION]}/year
                                </strong>{' '}
                                (that's just{' '}
                                {(
                                  (parseFloat(PLUS_PRICE[LOCALIZATION].replace(/[^0-9.]/g, '')) *
                                    100) /
                                  365
                                ).toFixed(0)}
                                c/day)!
                              </p>
                            )}
                            <AddToCartButton
                              label={t(CTA_VALUE)}
                              // adding={submitting}
                              oos={isOutOfStock}
                              handleClick={() => this.handleAddToCart(productInfo.withPlus)}
                            />
                            {size === 27 && (
                              <CalFeatureText style={{ textAlign: 'center' }}>
                                Pay{' '}
                                {IS_VIPBTS
                                  ? overRidePrices[LOCALIZATION].ogwithPlusDiscountedPrice
                                  : FormattedCurrency(productInfo.withPlus.price)}{' '}
                                today. You will be charged the {PLUS_PRICE[LOCALIZATION]} for
                                Calendar Plus one month after delivery.
                              </CalFeatureText>
                            )}
                          </ProductSelectionBox>
                        </ProductSelectionBoxWrapper>
                        <ClickableProductSelectionBox
                          onClick={() => {
                            this.handlePlusProduct(false)
                            this.setShownImageIndex(0)
                          }}
                        >
                          <ProductSelectionHeaderRow>
                            <ProductSelectionHeader>
                              <RadioIconContainer>
                                <GatsbyImage
                                  image={radioEmpty.childImageSharp.gatsbyImageData}
                                  alt="Save with Plus"
                                />
                              </RadioIconContainer>
                              <PlanHeading>
                                <Trans>Purchase without Plus</Trans>
                              </PlanHeading>
                            </ProductSelectionHeader>
                            <PriceAndExplainerContainer>
                              <ClickableProductSelectionPricePoint>
                                {showBfDesign ? (
                                  <ProductSelectionPricePoint>
                                    <>
                                      <strike>
                                        {FormattedCurrency(
                                          overRidePrices[LOCALIZATION].ogwithoutPlusPrice
                                        )}
                                      </strike>{' '}
                                      {FormattedCurrency(
                                        overRidePrices[LOCALIZATION].ogwithoutPlusDiscountedPrice
                                      )}
                                    </>
                                  </ProductSelectionPricePoint>
                                ) : (
                                  <Trans>{FormattedCurrency(productInfo.calendar.price)}</Trans>
                                )}
                              </ClickableProductSelectionPricePoint>
                              {!IS_FOREIGN_COUNTRY ? (
                                <ShopPay
                                  onTooltipClick={() => this.setDisplayToolTip(true)}
                                  size={size}
                                  style={style}
                                  amount={SHOP_PAY_AMOUNT}
                                />
                              ) : (
                                <OneTimePurchase>
                                  <Trans>One-Time Purchase</Trans>
                                </OneTimePurchase>
                              )}
                            </PriceAndExplainerContainer>
                          </ProductSelectionHeaderRow>
                        </ClickableProductSelectionBox>
                      </>
                    )}
                  </PickPriceContainer>
                  {!IS_FOREIGN_COUNTRY && !isOutOfStock && !isPreorder && <ShippingDetails />}
                  {IN_UK && <ShippingDetails />}
                </>
                <CalendarSyncs page="calendar-product" padding="0px" />
                <ShopifyDescription
                  dangerouslySetInnerHTML={{
                    __html: isPlusProduct
                      ? productInfo.withPlus.productDescription.descriptionHtml
                      : productInfo.calendar.productDescription.descriptionHtml,
                  }}
                />
              </ProductGridRight>
            </Grid>
          </Container>
          <Anchor id="review" />
          <ReviewsSection productId="6863425175604" name="The Skylight Calendar" />
          <FAQs page="calendarProductPage" />
        </Section>
      </>
    )
  }
}

CalendarProductPage.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
  t: PropTypes.func,
}

export const query = graphql`
  query ($handle: String!, $language: String!) {
    product: shopifyProduct(handle: { eq: $handle }) {
      id
      title
      handle
      productType
      description
      descriptionHtml
      shopifyId
      variants {
        id
        title
        price
        shopifyId
        sku
        product {
          images {
            id
            gatsbyImageData(width: 700, layout: FULL_WIDTH)
          }
          description
        }
      }
      images {
        id
        gatsbyImageData
      }
    }
    returnGuarantee: shopifyProduct(handle: { eq: "120-days-guarantee" }) {
      variants {
        storefrontId
      }
    }
    locales: allLocale(
      filter: { ns: { in: ["common", "frame-product"] }, language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    radioFull: file(relativePath: { eq: "icons/radio-full.webp" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    radioEmpty: file(relativePath: { eq: "icons/radio-empty.webp" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    dropdownicon: file(relativePath: { eq: "calendar/down-arrow.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, placeholder: NONE)
      }
    }
    dropupicon: file(relativePath: { eq: "calendar/up-arrow.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, placeholder: NONE)
      }
    }
    calMaxOgImage: file(relativePath: { eq: "meta-seo/calendar-max.jpg" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    cal15OgImage: file(relativePath: { eq: "meta-seo/calendar-15.jpg" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    customizedScreensaver: file(relativePath: { eq: "photo-screensaver-square.webp" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    mealPlanning: file(relativePath: { eq: "meal.webp" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    magicImport: file(relativePath: { eq: "magic-import.webp" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    calMaxClassicBlackIcon: file(relativePath: { eq: "calmax/classic-black-cal-max.webp" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    calMaxClassicWhiteIcon: file(relativePath: { eq: "calmax/classic-white-cal-max.webp" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    calMax15ClassicWhiteIcon: file(relativePath: { eq: "calmax/classic-white-15.jpg" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    calMaxShadowBoxAluminumIcon: file(relativePath: { eq: "calmax/shadow-box-aluminum.webp" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    calMaxShadowBoxCharcoalIcon: file(relativePath: { eq: "calmax/shadow-box-charcoal.webp" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    btsBadge: file(relativePath: { eq: "bts/back-to-school-sale.webp" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    badge: allContentfulFrameCalendarProductPageBadgeV2 {
      edges {
        node {
          usaCalendarBadge {
            gatsbyImageData(placeholder: NONE)
          }
          showPdpBadge
        }
      }
    }
    contentfulCTAOverrides: allContentfulCtaCopyOnFrameAndCalendarPdp {
      edges {
        node {
          en_10_calendar
          en_15_calendar
          en_27_aluminum_calendar
          en_27_charcoal_calendar
          en_27_white_calendar
          en_27_black_calendar
          en_ca_15_calendar
          en_ca_27_white_calendar
          en_ca_27_aluminum_calendar
          en_au_15_calendar
          en_au_27_white_calendar
          en_au_27_aluminum_calendar
          en_gb_15_calendar
          en_gb_27_white_calendar
          en_gb_27_aluminum_calendar
        }
      }
    }
    contentfulCalPrice: allContentfulCalendarStrikeThoughPrice {
      edges {
        node {
          en_gb_show_override_prices
          en_gb_cal_15_with_plus_original_price
          en_gb_cal_15_without_plus_original_price
          en_gb_cal_15_with_plus_discounted_price
          en_gb_cal_15_without_plus_discounted_price
          en_ca_show_override_prices
          en_ca_cal_15_with_plus_original_price
          en_ca_cal_15_without_plus_original_price
          en_ca_cal_15_with_plus_discounted_price
          en_ca_cal_15_without_plus_discounted_price
          en_au_show_override_prices
          en_au_cal_15_with_plus_original_price
          en_au_cal_15_without_plus_original_price
          en_au_cal_15_with_plus_discounted_price
          en_au_cal_15_without_plus_discounted_price
        }
      }
    }
    backorder: contentfulBackorder(product: { eq: "calendar_max" }) {
      onBackorder
      backorderVariants
      shadow_box_natural_aluminum {
        raw
      }
      shadow_box_charcoal {
        raw
      }
      classic_white {
        raw
      }
      classic_black {
        raw
      }
      color
      product
    }
  }
`

CalendarProductPage.contextType = StoreContext

export default withTranslation()(CalendarProductPage)
